import { Component } from '@angular/core';

@Component({
  standalone: false,
    selector: 'faro-demo-component',
    templateUrl: './demo.component.html',
    styleUrls: ['./demo.component.scss'],
})
export class DemoComponent {
    constructor() {}
}
